import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "file"
const FileIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.5 21H4.5V1.5L4.347 1.508C3.59 1.585 3 2.223 3 3V21C3 21.828 3.672 22.5 4.5 22.5H19.5C20.328 22.5 21 21.828 21 21V8.25L14.25 1.5H4.5V3H13.5V6.75C13.5 7.993 14.507 9 15.75 9H19.5zM15 4.371 18.129 7.5H15.75C15.336 7.5 15 7.164 15 6.75z" />
        </svg>
      }
    </span>
  )
}
export default FileIcon
